(() => {
  function getRoot(element) {
    return element.closest('[data-general-options]');
  }

  function getForm(root) {
    return document.getElementById(root.dataset.productFormId);
  }

  function syncMeasurementUnits(root) {
    const useCm = root.querySelector('[data-general-unit]')?.value === 'CM';
    const panel = root.querySelector('[data-general-custom-panel]');
    const isCustom = panel && !panel.hidden;

    root.querySelectorAll('[data-measurement-inch]').forEach((select) => {
      select.hidden = useCm;
      select.disabled = !isCustom || useCm;
    });
    root.querySelectorAll('[data-measurement-cm]').forEach((select) => {
      select.hidden = !useCm;
      select.disabled = !isCustom || !useCm;
    });
  }

  const sizeMeasurements = {
    US0: { bust: '32.5', waist: '25', hips: '35.5', hollow: '58', height: '65' },
    US2: { bust: '33.5', waist: '26', hips: '36.5', hollow: '58', height: '65' },
    US4: { bust: '34.5', waist: '27', hips: '37.5', hollow: '59', height: '65' },
    US6: { bust: '35.5', waist: '28', hips: '38.5', hollow: '59', height: '65' },
    US8: { bust: '36.5', waist: '29', hips: '39.5', hollow: '60', height: '65' },
    US10: { bust: '37.5', waist: '30', hips: '40.5', hollow: '60', height: '65' },
    US12: { bust: '39', waist: '31.5', hips: '42', hollow: '61', height: '65' },
    US14: { bust: '40.5', waist: '33', hips: '43.5', hollow: '61', height: '65' },
    US16: { bust: '42', waist: '34.5', hips: '45', hollow: '61', height: '65' },
    US14W: { bust: '41', waist: '33.5', hips: '45', hollow: '61', height: '65' },
    US16W: { bust: '43', waist: '35.5', hips: '47.5', hollow: '61', height: '65' }
  };

  function validateSize(root) {
    const sizeGroup = root.querySelector('[data-general-size-group]');
    if (!sizeGroup) return true;

    const selected = sizeGroup.querySelector('[data-general-size]:checked');
    const error = sizeGroup.querySelector('[data-general-size-error]');
    if (selected) {
      if (error) error.hidden = true;
      return true;
    }

    if (error) {
      error.hidden = false;
      error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return false;
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    const root = input instanceof Element ? getRoot(input) : null;
    if (!root) return;

    if (input.matches('[data-general-color]')) {
      const selected = root.querySelector('[data-general-color-selected]');
      if (selected) selected.textContent = input.value;
      return;
    }

    if (input.matches('[data-general-unit]')) {
      syncMeasurementUnits(root);
      return;
    }

    if (!input.matches('[data-general-size]')) return;

    const selected = root.querySelector('[data-general-size-selected]');
    if (selected) selected.textContent = input.value;

    const form = getForm(root);
    const variantInput = form?.querySelector('input[name="id"]');
    if (variantInput && input.dataset.variantId) {
      variantInput.value = input.dataset.variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const isCustom = input.hasAttribute('data-custom-size');
    const valuesContainer = root.querySelector('[data-general-size-values]');
    const measurements = sizeMeasurements[input.value.replace(/\s/g, '').toUpperCase()];
    if (valuesContainer) {
      valuesContainer.hidden = isCustom || !measurements;
      if (measurements) {
        Object.entries(measurements).forEach(([name, value]) => {
          const cell = valuesContainer.querySelector(`[data-size-value="${name}"]`);
          if (cell) cell.textContent = value;
        });
      }
    }

    const chart = root.querySelector('[data-general-size-chart]');
    if (chart) {
      chart.hidden = isCustom;
      if (isCustom) chart.open = false;
    }

    const panel = root.querySelector('[data-general-custom-panel]');
    if (panel) {
      panel.hidden = !isCustom;
      panel.querySelectorAll('[data-general-measurement]').forEach((field) => {
        field.disabled = !isCustom;
      });
      if (isCustom) syncMeasurementUnits(root);
    }

    validateSize(root);
  });

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button[type="submit"], input[type="submit"]');
      if (!button) return;
      const form = button.form || button.closest('form');
      if (!form) return;
      const root = document.querySelector(`[data-general-options][data-product-form-id="${form.id}"]`);
      if (!root) return;

      if (!validateSize(root)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const root = document.querySelector(
        `[data-general-options][data-product-form-id="${event.target.id}"]`
      );
      if (!root) return;

      if (!validateSize(root)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-general-options]').forEach(syncMeasurementUnits);
  });
})();
